import t from "../../../utilities/tw.js";
const o = {
  base: t`max-w-full rounded-md shadow-md`,
  item: t`mx-6 mt-px overflow-hidden border-b px-1 py-4 first:mt-0 last:border-0 focus-within:relative focus-within:z-10`,
  trigger: t`group flex h-[45px] w-full flex-1 cursor-pointer items-center justify-between bg-neutral text-xl/1 font-bold tracking-[0.3px] outline-offset-2 focus-visible:outline-2`,
  content: t`overflow-hidden text-base data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown`,
  icon: t`size-6 fill-focus transition-transform duration-300 group-data-[state=open]:rotate-180`
};
export {
  o as accordionStyles
};
